import firebaseApp from "services/firebase";

const functions = firebaseApp.functions();

const generateReportPdfCallable = functions.httpsCallable("generateReportPdf", {
  timeout: 120000,
});

function base64ToBlob(base64, mimeType) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mimeType });
}

export async function exportInstitutionReportPdf({
  institutionId,
  startPeriodKey,
  endPeriodKey,
  dimension,
  metrics,
}) {
  const result = await generateReportPdfCallable({
    institutionId,
    startPeriodKey,
    endPeriodKey,
    dimension,
    metrics,
  });

  const { pdfBase64, fileName, mimeType } = result?.data || {};
  if (!pdfBase64) {
    throw new Error("PDF export did not return file data.");
  }

  const blob = base64ToBlob(pdfBase64, mimeType || "application/pdf");
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName || "institution-report.pdf";
  anchor.click();
  URL.revokeObjectURL(url);
}
